import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { autobind } from 'core-decorators';
import BaseDialog from 'components/BaseDialog';
import scmp, { FlexColContainer, FlexRowContainer } from 'components/StyledComp';
import TableChangeHistories from 'components-desktop/histories/TableChangeHistories';

const propTypes = {
  table: PropTypes.string.isRequired,

  rowId: PropTypes.number,
  patientId: PropTypes.number,
  caregiverId: PropTypes.number,
};

@autobind
class ChangeHistoriesDialog extends BaseDialog {
  constructor(props) {
    super(props);

    this.state = {
      changeHistories: null,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { table, rowId, patientId, caregiverId, isVisible } = this.props;

    if ((table && (rowId || patientId || caregiverId)) && (
      (isVisible && !prevProps.isVisible) ||
      (table !== prevProps.table) ||
      (rowId !== prevProps.rowId) ||
      (patientId !== prevProps.patientId) ||
      (caregiverId !== prevProps.caregiverId)
    )) {
      this.getChangeHistories();
    }
  }

  async getChangeHistories() {
    const params = {
      table: this.props.table,
      rowId: this.props.rowId,
      patientId: this.props.patientId,
      caregiverId: this.props.caregiverId,
    };
    const changeHistories =
      await this.callServiceForRemoteObjects('/change_history/get_list', params);

    this.setState({
      changeHistories,
    });
  }

  render() {
    const { isVisible, ...layoutProps } = this.props;
    const { changeHistories } = this.state;

    return (
      <scmp.AntdModal
        {...layoutProps}
        // maxWidth="700px"
        style={{ top: 20 }}
        bodyStyle={{ padding: '8px 8px' }}
        visible={isVisible}
        centered
        maskClosable
        footer={null}
        afterClose={this.onModalHide}
        onOk={this.onOkClick}
        onCancel={this.onOkClick}
      >
        <FlexColContainer
          width="match_parent"
          height="wrap_content"
          padding="4px 4px"
          alignItems="center"
        >
          <Spin
            style={{ margin: '16px 0' }}
            spinning={!changeHistories}
            delay={200}
          />

          {changeHistories &&
            <TableChangeHistories
              width="match_parent"
              height="wrap_content"
              margin="0 0 20px 0"
              color="yellow_gold"
              title="Change Histories"
              changeHistories={changeHistories}
            />
          }

          <FlexRowContainer
            width="wrap_content"
            height="wrap_content"
          >
            <scmp.AntdButton
              width="wrap_content"
              height="32px"
              fontSize="14px"
              type="default"
              onClick={this.onOkClick}
            >
              OK
            </scmp.AntdButton>
          </FlexRowContainer>
        </FlexColContainer>
      </scmp.AntdModal>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
ChangeHistoriesDialog.propTypes = propTypes;

export default ChangeHistoriesDialog;
